/** ******************************************************** */


/** **************** Global Setting ************************ */

import "./polyfill";
import exceptionReport from "./exceptionReport";
/** **************** Global style ************************ */
// 这里之所以把antd style 一次性载入, 是为了方便后面style覆盖
// (NOTE: 这种方式会载入所有组件的样式, 无法和按需加载插件 babel-plugin-import 的 style 属性一起使用.)
// .babelrc
// [
//     "import",
//     {
//         "libraryName": "antd",
//         "style": "css"
//     }
// ]
// Dingding NOTE 2. <link rel="stylesheet" type="text/css" href="./lib/antd/3.1.0/antd.min.css">
import "antd/dist/antd.min.css";
// 重定义 ant.design 组件样式
import "../custom/style";
// Dingding NOTE 3.
// @2018-02-27
// 浙二医院通过 内网服务器代理dingding服务器(nursecare-duty-schedule服务), 因此需要将antd字体(iconfont)也一起打包进去
import "../asset/font";
// 项目公共 style
import "../style";
import React from "react";
import ReactDOM from "react-dom";

import {Provider} from "react-redux";
import {HashRouter, Route} from "react-router-dom";

// Dingding NOTE 4.
import {ConfigProvider} from "antd";
import zhCN from "antd/es/locale-provider/zh_CN";
// Dingding NOTE 5: dingding 的 LocaleProvider来自 antd-with-locales(<script src="./lib/antd/3.1.0/antd-with-locales.min.js" type="text/javascript"></script>),
// 1. .\src\custom\modal\confirm.js 有应用 antd/es/modal/locale.getConfirmLocale, 因此这里要手动调用 antd/es/modal/locale.changeConfirmLocale
// 2. 其他情况 antd-with-locales 里的 LocaleProvider/LocaleReceiver刚好能对应
import {changeConfirmLocale} from "antd/es/modal/locale";
import MainView from "../view/main/MainView";
import rootViewModel from "../viewmodel";
import AppContext from "./AppContext";
import createStore from "./createStore";

/** ******************************************************** */

exceptionReport.init();

changeConfirmLocale(zhCN && zhCN.Modal);


const store = createStore(rootViewModel);
AppContext.store = store;


const layoutRoot = document.getElementById("layoutRoot");
// browser: {name: "Chrome", version: "69.0.3497.100"}
// engine: {name: "Blink"}
// os: {name: "Windows", version: "NT 10.0", versionName: "10"}
// platform: {type: "desktop"}


// https://stackoverflow.com/questions/49954618/babel-not-transpiling-arrow-functions-webpack
// Babel not transpiling arrow functions (Webpack)

// A:
// I think an issue is related to query-string because it's written in ES6 and not transpiled to ES5. Try to downgrade version from 6 to 5.
//
// yarn add query-string@5.1.1

// https://github.com/babel/babel/issues/7887
// Arrow functions returned by a switch #7887


// NOTE: 目前 "query-string": "^6.1.0" 因为目前会强制要求Chrome 浏览器
const root = ReactDOM.createRoot(layoutRoot);
root.render(<ConfigProvider locale={zhCN}>
    <Provider store={store}>
        <HashRouter>
            <MainView />
        </HashRouter>
    </Provider>
            </ConfigProvider>);

/* const renderApp = (root) => {
    ReactDOM.render(
        <ConfigProvider locale={zhCN}>
            <Provider store={store}>
                <HashRouter>
                    <MainView />
                </HashRouter>
            </Provider>
        </ConfigProvider>,
        layoutRoot,
    );
};
 */

// if (module.hot) {
//     module.hot.accept("../viewmodel", () => {
//         const nextRootViewModel = require("../viewmodel").default;
//         store.replaceReducer(nextRootViewModel);
//     });
//     module.hot.accept("../view/main/MainView", () => {
//         const state = store.getState();
//         const holdStateReducer = () => state;
//         store.replaceReducer(holdStateReducer);
//
//         ReactDOM.unmountComponentAtNode(layoutRoot);
//
//         const nextRootViewModel = require("../viewmodel").default;
//         store.replaceReducer(nextRootViewModel);
//
//         const nextMainView = require("../view/main/MainView").default;
//         renderApp(nextMainView);
//     });
// }


/* renderApp(MainView); */
